export default {
    COMMON: {
        OK: '処理成功しました。',
        FAILED: '処理失敗しました。',
        AUTH_INVALID: '処理失敗しました。',
        IMPORT_CSV_SUCCESS: 'CSVインポート成功',
        IMPORT_CSV_FAILED: 'CSVインポート失敗しました。',
        EXPORT_CSV_FAILED: 'CSVエクスポート失敗しました。',
        GET_IMAGE_FAILED: '画像情報の取得に失敗しました。',
        UPLOAD_IMAGE_LIMIT: '最大3枚までアップロードできます。',
        UPLOAD_IMAGE_SUCCESS: '画像アップロード成功',
        UPLOAD_IMAGE_FAILED: '画像アップロード失敗しました。',
        FILE_INVALID: 'ファイルが無効です',
        FILE_LARGE: 'ファイルが大きすぎます。',
        LOGIN: 'ログインしました！',
        LOGOUT: 'ログアウトしました！',
        DEPARTMENT_HEAD_EXIST: '本部機関が存在します。',
        DELETE_FAILED_INVENTORY_EXISTS: '在庫が存在するため削除できません。',
    },
    ORGANIZATION: {
        GET_LIST_FAILED: '組織リストの取得に失敗しました。',
        GET_DETAIL_FAILED: '組織情報の取得に失敗しました。',
        NOT_FOUND: '該当する組織が存在しません。',
        ALREADY_EXIST: 'この組織コードは既に存在します。',
        CREATE_FAILED: '新規組織の登録に失敗しました。',
        UPDATE_FAILED: '組織の更新に失敗しました。',
        DELETE_FAILED: '組織の削除に失敗しました。',
    },
    DEPARTMENT: {
        GET_LIST_FAILED: '部門リストの取得に失敗しました。',
        GET_DETAIL_FAILED: '部門情報の取得に失敗しました。',
        NOT_FOUND: '該当する部門が存在しません。',
        ALREADY_EXIST: 'この部門コードは既に存在します。',
        CREATE_FAILED: '新規部門の登録に失敗しました。',
        UPDATE_FAILED: '部門の更新に失敗しました。',
        DELETE_FAILED: '部門の削除に失敗しました。',
    },
    CATEGORY: {
        GET_LIST_FAILED: 'カテゴリリストの取得に失敗しました。',
        GET_DETAIL_FAILED: 'カテゴリ情報の取得に失敗しました。',
        NOT_FOUND: '該当するカテゴリが存在しません。',
        ALREADY_EXIST: 'このカテゴリコードは既に存在します。',
        CREATE_FAILED: '新規カテゴリの登録に失敗しました。',
        UPDATE_FAILED: 'カテゴリの更新に失敗しました。',
        DELETE_FAILED: 'カテゴリの削除に失敗しました。',
    },
    MATERIAL: {
        GET_LIST_FAILED: '材料リストの取得に失敗しました。',
        GET_DETAIL_FAILED: '材料情報の取得に失敗しました。',
        NOT_FOUND: '該当する材料が存在しません。',
        ALREADY_EXIST: 'この材料JANコードは既に存在します。',
        CREATE_FAILED: '新規材料の登録に失敗しました。',
        UPDATE_FAILED: '材料の更新に失敗しました。',
        DELETE_FAILED: '材料の削除に失敗しました。',
    },
    USER: {
        GET_LIST_FAILED: 'ユーザーリストの取得に失敗しました。',
        GET_DETAIL_FAILED: 'ユーザー情報の取得に失敗しました。',
        NOT_FOUND: '該当するユーザーが存在しません。',
        ALREADY_EXIST: 'このユーザーコードは既に存在します。',
        CREATE_FAILED: '新規ユーザーの登録に失敗しました。',
        UPDATE_FAILED: 'ユーザーの更新に失敗しました。',
        DELETE_FAILED: 'ユーザーの削除に失敗しました。',
    },
    ALERT: {
        GET_LIST_FAILED: 'アラートメッセージリストの取得に失敗しました。',
        GET_DETAIL_FAILED: 'アラートメッセージ情報の取得に失敗しました。',
        NOT_FOUND: '該当するアラートメッセージが存在しません。',
        ALREADY_EXIST: 'このアラートメッセージは既に存在します。',
        CREATE_FAILED: '新規アラートメッセージの登録に失敗しました。',
        UPDATE_FAILED: 'アラートメッセージの更新に失敗しました。',
        DELETE_FAILED: 'アラートメッセージの削除に失敗しました。',
        SEND_NOTIFICATION_FAILED: '通知の送信に失敗しました。',
        SEND_NOTIFICATION_SUCCESS: 'アラートメッセージを受信済みとしてマークしました。',
        SEND_NOTIFICATION_AGAIN: 'アラートメッセージを再送しました。',
    },
    INVENTORY: {
        GET_LIST_FAILED: '在庫リストの取得に失敗しました。',
        GET_DETAIL_FAILED: '在庫情報の取得に失敗しました。',
        NOT_FOUND: '該当する在庫記録が存在しません。',
        ALREADY_EXIST: 'この在庫記録は既に存在します。',
        CREATE_FAILED: '新規在庫の登録に失敗しました。',
        UPDATE_FAILED: '在庫の更新に失敗しました。',
        DELETE_FAILED: '在庫の削除に失敗しました。',
        MATERIAL_AND_GROUP_IMFORMATION_NOT_MATCH: '材料とグループ情報が一致しません。',
        EXCEEDING_MATERIAL_EXPIRATION_DAY: '保管日が有効期限を超えています。',
    },
    PAYMENT: {
        GET_LIST_FAILED: '払出リストの取得に失敗しました。',
        GET_DETAIL_FAILED: '払出情報の取得に失敗しました。',
        NOT_FOUND: '該当する払出が存在しません。',
        ALREADY_EXIST: 'この払出は既に存在します。',
        CREATE_FAILED: '新規払出の登録に失敗しました。',
        UPDATE_FAILED: '払出の更新に失敗しました。',
        DELETE_FAILED: '払出の削除に失敗しました。',
    },
    SETTING: {
        TRICK_PROCESS_SUCCESS: '定期処理が成功しました。',
        TRICK_PROCESS_FAILED: '定期処理が失敗しました。',
        GET_MAIL_SETTING_FAILED: 'メール設定の取得に失敗しました。',
        SAVE_MAIL_SETTING_SUCCESS: 'メール設定の保存に成功しました。',
        SAVE_MAIL_SETTING_FAILED: 'メール設定の保存に失敗しました。',
        GET_ALARM_SETTING_FAILED: 'アラート設定の取得に失敗しました。',
        SAVE_ALARM_SETTING_SUCCESS: 'アラート設定の保存に成功しました。',
        SAVE_ALARM_SETTING_FAILED: 'アラート設定の保存に失敗しました。',
        GET_CRON_TIME_FAILED: '定期タスクの取得に失敗しました。',
        SAVE_CRON_TIME_SUCCESS: '定期タスクの更新に成功しました。',
        SAVE_CRON_TIME_FAILED: '定期タスクの更新に失敗しました。',
    },
    PERSONAL_SETTING: {
        GET_LIST_FAILED: 'トークンリストの取得に失敗しました。',
        GET_DETAIL_FAILED: 'トークン情報の取得に失敗しました。',
        NOT_FOUND: '該当するトークンが存在しません。',
        ALREADY_EXIST: 'このトークンは既に存在します。',
        CREATE_FAILED: '新規トークンの登録に失敗しました。',
        UPDATE_FAILED: 'トークンの更新に失敗しました。',
        DELETE_FAILED: 'トークンの削除に失敗しました。',
        PASSWORD_INCORRECT: 'パスワードの変更に失敗しました。',
        CHANGE_PASSWORD_SUCCESS: 'パスワードの変更に成功しました。',
        CHANGE_PASSWORD_FAILED: 'パスワードの変更に失敗しました。',
    },
    JANCODE: {
        GET_LIST_FAILED: 'JANコードリストの取得に失敗しました。',
        GET_DETAIL_FAILED: 'JANコード情報の取得に失敗しました。',
        NOT_FOUND: '該当するJANコードが存在しません。',
        ALREADY_EXIST: 'このJANコードは既に存在します。',
        CREATE_FAILED: '新規JANコードの登録に失敗しました。',
        UPDATE_FAILED: 'JANコードの更新に失敗しました。',
        DELETE_FAILED: 'JANコードの削除に失敗しました。',
    },
    HISTORY: {
        GET_LIST_FAILED: '履歴リストの取得に失敗しました。',
        GET_DETAIL_FAILED: '履歴情報の取得に失敗しました。',
        NOT_FOUND: '該当する履歴が存在しません。',
        ALREADY_EXIST: 'この履歴は既に存在します。',
        CREATE_FAILED: '新規履歴の登録に失敗しました。',
        UPDATE_FAILED: '履歴の更新に失敗しました。',
        DELETE_FAILED: '履歴の削除に失敗しました。',
        EXPORT_FAILED: '履歴のエクスポートに失敗しました。',
    }
};